var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgESearchFolder = function SvgESearchFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22a4 4 0 0 1 4-4h18.333a4 4 0 0 1 2.4.8l6.934 5.2H80a4 4 0 0 1 4 4v46a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V22zm22.333 0H16v52h64V28H43.667a4 4 0 0 1-2.4-.8L34.333 22zM21 68a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H23a2 2 0 0 1-2-2zm27.393-14.293a8 8 0 1 1 11.314-11.314 8 8 0 0 1-11.314 11.314zm-2.828-14.142c-4.686 4.686-4.686 12.284 0 16.97 4.204 4.205 10.753 4.637 15.439 1.297l6.582 6.582a2 2 0 1 0 2.828-2.828l-6.582-6.582c3.34-4.686 2.908-11.235-1.297-15.439-4.686-4.686-12.284-4.686-16.97 0z"
  })));
};

export default SvgESearchFolder;